/* eslint-disable no-unused-vars */
import React, { useState, useRef } from 'react';

function ProductMappingRow({ product, mapping, onSave, games }) {
  const [type, setType]           = useState(mapping?.type || '');
  const [modelGame, setModelGame] = useState(mapping?.modelGame || '');
  const [saved, setSaved]         = useState(!!mapping?.type);
  const isDirty = type !== (mapping?.type || '') || modelGame !== (mapping?.modelGame || '');

  const handleSave = () => {
    onSave(product.product_name, type, modelGame, null);
    setSaved(true);
  };

  return (
    <tr style={{ borderBottom: '1px solid var(--e0)' }}>
      <td style={{ padding: '5px 10px', fontSize: 11, color: 'var(--t1)' }}>{product.product_name}</td>
      <td style={{ padding: '5px 8px', fontSize: 10, color: 'var(--t3)' }}>{product.game_name}</td>
      <td style={{ padding: '5px 8px' }}>
        <select value={type} onChange={e => { setType(e.target.value); setModelGame(''); setSaved(false); }}
          style={{ fontSize: 11, padding: '3px 20px 3px 6px', width: '100%' }}>
          <option value="">— unmapped —</option>
          <option value="base_game">Base Game</option>
          <option value="dlc">DLC</option>
          <option value="ignore">Ignore</option>
        </select>
      </td>
      <td style={{ padding: '5px 8px' }}>
        {(type === 'base_game' || type === 'dlc') && (
          <select value={modelGame} onChange={e => { setModelGame(e.target.value); setSaved(false); }}
            style={{ fontSize: 11, padding: '3px 20px 3px 6px', width: '100%' }}>
            <option value="">— select game —</option>
            {(games || []).map(g => <option key={g} value={g}>{g}</option>)}
          </select>
        )}
        {type === 'ignore' && <span style={{ fontSize: 10, color: 'var(--t4)', fontStyle: 'italic' }}>Will not be imported</span>}
      </td>
      <td style={{ padding: '5px 8px', textAlign: 'center' }}>
        {isDirty ? (
          <button onClick={handleSave}
            style={{ fontSize: 9, padding: '3px 10px', background: 'var(--blue-dim)', border: '1px solid var(--blue)', color: 'var(--blue)', borderRadius: 'var(--r)', cursor: 'pointer' }}>
            Save
          </button>
        ) : saved ? (
          <span style={{ fontSize: 10, color: 'var(--green)' }}>✓</span>
        ) : null}
      </td>
    </tr>
  );
}

export default function SteamUploadPanel({ uploads, products, mappings, monthlyUnits, loading, uploadSteam, saveMapping, games }) {
  const [uploading, setUploading]   = useState(false);
  const [uploadMsg, setUploadMsg]   = useState('');
  const [filterMapped, setFilterM]  = useState('all');
  const fileRef = useRef();

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    setUploadMsg('Parsing file…');
    try {
      const text = await file.text();
      setUploadMsg('Uploading to database…');
      const result = await uploadSteam(text, file.name, mappings);
      setUploadMsg(`✓ Uploaded ${file.name} — ${result.rowCount.toLocaleString()} rows across ${result.months.length} months (${result.months[0]} to ${result.months[result.months.length - 1]})`);
    } catch (err) {
      setUploadMsg(`⚠ Error: ${err.message}`);
    }
    setUploading(false);
    if (fileRef.current) fileRef.current.value = '';
  };

  const mapped   = products.filter(p => mappings[p.product_name]?.type && mappings[p.product_name]?.type !== 'ignore').length;
  const ignored  = products.filter(p => mappings[p.product_name]?.type === 'ignore').length;
  const unmapped = products.length - mapped - ignored;

  const filtered = products.filter(p => {
    if (filterMapped === 'mapped'   && !mappings[p.product_name]?.type) return false;
    if (filterMapped === 'unmapped' && mappings[p.product_name]?.type)  return false;
    return true;
  });

  const th = { padding: '6px 10px', fontSize: 9, color: 'var(--t4)', textAlign: 'left', fontWeight: 400, letterSpacing: '.08em', textTransform: 'uppercase', background: 'var(--s1)', whiteSpace: 'nowrap' };

  return (
    <div>
      {/* Upload */}
      <div className="card" style={{ marginBottom: 14 }}>
        <div className="card-head">
          <span className="card-title">Upload Steam Sales Report</span>
          <span className="card-meta">CSV export from Steamworks</span>
        </div>
        <div className="card-body">
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
            <input ref={fileRef} type="file" accept=".csv" onChange={handleFile} disabled={uploading}
              style={{ fontSize: 12, color: 'var(--t2)' }} />
          </div>
          {uploadMsg && (
            <div style={{ fontSize: 11, color: uploadMsg.startsWith('⚠') ? 'var(--red)' : 'var(--green)',
              padding: '6px 10px', background: 'var(--s1)', borderRadius: 'var(--r)', border: '1px solid var(--e0)', marginBottom: 8 }}>
              {uploadMsg}
            </div>
          )}
          <div style={{ fontSize: 10, color: 'var(--t4)' }}>
            Upload the CSV from Steamworks → Reports → Sales. Map products to model games below. Units, RRP and regional discount will flow into Game Assumptions for locked months.
          </div>
        </div>
      </div>

      {/* Upload history */}
      {uploads.length > 0 && (
        <div className="card" style={{ marginBottom: 14 }}>
          <div className="card-head"><span className="card-title">Upload History</span></div>
          <div className="card-body" style={{ padding: 0 }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  {['File','Uploaded','Period','Rows'].map(h => <th key={h} style={th}>{h}</th>)}
                </tr>
              </thead>
              <tbody>
                {uploads.map(u => (
                  <tr key={u.id} style={{ borderBottom: '1px solid var(--e0)' }}>
                    <td style={{ padding: '5px 10px', fontSize: 12, color: 'var(--t1)' }}>{u.filename}</td>
                    <td style={{ padding: '5px 10px', fontSize: 11, color: 'var(--t3)' }}>
                      {new Date(u.uploaded_at).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
                    </td>
                    <td style={{ padding: '5px 10px', fontSize: 11, color: 'var(--t3)' }}>
                      {u.date_range_from?.slice(0,7)} → {u.date_range_to?.slice(0,7)}
                    </td>
                    <td style={{ padding: '5px 10px', fontSize: 11, color: 'var(--t3)' }}>
                      {(u.row_count || 0).toLocaleString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}



      {/* Product mapping */}
      {products.length > 0 && (
        <div className="card">
          <div className="card-head">
            <span className="card-title">Product Mapping</span>
            <span className="card-meta">{mapped} mapped · {ignored} ignored · {unmapped} unmapped</span>
          </div>
          <div className="card-body" style={{ padding: 0 }}>
            <div style={{ display: 'flex', gap: 12, padding: '10px 16px', borderBottom: '1px solid var(--e0)' }}>
              <span style={{ fontSize: 9, color: 'var(--t3)', textTransform: 'uppercase', letterSpacing: '.08em', alignSelf: 'center' }}>Show</span>
              <select value={filterMapped} onChange={e => setFilterM(e.target.value)} style={{ fontSize: 11 }}>
                <option value="all">All Products</option>
                <option value="unmapped">Unmapped only</option>
                <option value="mapped">Mapped only</option>
              </select>
            </div>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    {['Steam Product Name','Steam Game','Type','Maps To',''].map(h => <th key={h} style={th}>{h}</th>)}
                  </tr>
                </thead>
                <tbody>
                  {filtered.map(p => (
                    <ProductMappingRow key={p.product_name} product={p}
                      mapping={mappings[p.product_name]}
                      onSave={saveMapping}
                      games={games} />
                  ))}
                  {filtered.length === 0 && (
                    <tr><td colSpan={5} className="nomsg">No products match the current filter.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {products.length === 0 && !loading && (
        <div className="nomsg">No Steam data yet — upload a sales CSV to get started.</div>
      )}
    </div>
  );
}
